import React, { useEffect } from "react";
import { connect } from "react-redux";
import { changeOrderStatus } from "../../redux/Actions/OrderActions";
import DeleteModal from "../Modal/DeleteModal";

const DeleveredOrder = (props) => {
  const { changeOrderStatus, id, isChangingStatus, changeSuccess } = props;

  useEffect(
    () => {
      if (changeSuccess) {
        props.closeModal();
      }
    }, // eslint-disable-next-line
    [changeSuccess]
  );

  const payload = {
    status: "delivered",
  };

  const handleChange = () => {
    changeOrderStatus(id, payload);
  };
  return (
    <DeleteModal
      displayModal={props.displayModal}
      closeModal={props.closeModal}
      title={"Change order status to delivered?"}
      width={"463px"}
      text={"Delivered"}
      onClick={handleChange}
      disabled={isChangingStatus}
      isLoading={isChangingStatus}
      activate={true}
      loadingText={"Delivering..."}
      children={
        "Once you change this order status, this order would show as delivered. Change to delivered?"
      }
    />
  );
};

const mapStateToProps = (state) => ({
  isChangingStatus: state.order.isChangingStatus,
  changeSuccess: state.order.changeSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  changeOrderStatus: (id, payload) => dispatch(changeOrderStatus(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleveredOrder);
